import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAddressCard } from "@fortawesome/free-regular-svg-icons"

export const AddressCard = (props) => {
  return <FontAwesomeIcon faIcon={faAddressCard} {...props} />
}
